import React, { useState } from "react";
import { Select, Table, Modal, Button } from "antd";
import { ExportToExcel } from "../../../../utils";

export const LocationFilter = ({ data }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState([
    {
      customerName: "",
      phoneNumber: "",
      saleAmount: 0,
      categorias: [],
      marcas: [],
    },
  ]);

  const uniqueDepartment = Array.from(
    new Set(data?.map((item) => item.department))
  );
  const uniqueProvince = Array.from(new Set(data?.map((item) => item.province)));
  const uniqueDistrict = Array.from(new Set(data?.map((item) => item.district)));

  const [filterLocation, setFilterLocation] = useState("department");
  const [selectedFilter, setSelectedFilter] = useState(null);

  const filteredData = data?.filter((item) => {
    if (filterLocation === "department") {
      if (selectedFilter && selectedFilter !== item.department) {
        return false;
      }
    }
    if (filterLocation === "province") {
      if (selectedFilter && selectedFilter !== item.province) {
        return false;
      }
    }
    if (filterLocation === "district") {
      if (selectedFilter && selectedFilter !== item.district) {
        return false;
      }
    }

    return true;
  });

  const getTotalByDepartment = (department) => {
    return filteredData
      .filter((item) => item.department === department)
      .reduce((total, item) => total + item.saleAmount, 0);
  };

  const getTotalByProvince = (province) => {
    return filteredData
      .filter((item) => item.province === province)
      .reduce((total, item) => total + item.saleAmount, 0);
  };

  const getTotalByDistrict = (district) => {
    return filteredData
      .filter((item) => item.district === district)
      .reduce((total, item) => total + item.saleAmount, 0);
  };

  const handleFilterTypeChange = (value) => {
    setFilterLocation(value);
    setSelectedFilter(null);
  };

  const getDetailsByDepartment = (department) => {
    const items = filteredData
      .filter((item) => item.department === department)
      .flatMap((item) => item.products);

    const categorias = Array.from(new Set(items.map((item) => item.category)));
    const marcas = Array.from(new Set(items.map((item) => item.brand)));

    return { categorias, marcas };
  };

  const getDetailsByProvince = (province) => {
    const items = filteredData
      .filter((item) => item.province === province)
      .flatMap((item) => item.products);

    const categorias = Array.from(new Set(items?.map((item) => item.category)));
    const marcas = Array.from(new Set(items?.map((item) => item.brand)));

    return { categorias, marcas };
  };

  const getDetailsByDistrict = (district) => {
    const items = filteredData
      .filter((item) => item.district === district)
      .flatMap((item) => item.products);

    const categorias = Array.from(new Set(items?.map((item) => item.category)));
    const marcas = Array.from(new Set(items?.map((item) => item.brand)));

    return { categorias, marcas };
  };

  const showModal = (record) => {
    const detailsData = data
      .filter((item) => {
        if (filterLocation === "department") {
          return item.department === record.department;
        }
        if (filterLocation === "province") {
          return item.province === record.province;
        }
        if (filterLocation === "district") {
          return item.district === record.district;
        }
        return false;
      })
      .map((item) => {
        const categorias = Array.from(
          new Set(item.products.map((i) => i.category))
        );
        const marcas = Array.from(new Set(item.products?.map((i) => i.brand)));
        const totalProducts = item.products.length;
        const lastOrderDate = new Date(
          item.dateStart.seconds * 1000
        ).toLocaleDateString();

        return {
          customerName: item.customerName,
          phoneNumber: item.phoneNumber,
          saleAmount: item.saleAmount,
          categorias,
          marcas,
          totalProducts,
          lastOrderDate,
        };
      });

    setModalData(detailsData);
    setIsModalVisible(true);
  };

  const totalSales = filteredData?.reduce(
    (total, item) => total + item.saleAmount,
    0
  );

  const columns = [
    {
      title: (
        <div>
          <Select
            defaultValue={filterLocation}
            onChange={handleFilterTypeChange}
            style={{ marginLeft: "1rem", width: 140 }}
          >
            <Select.Option value="department">Departamento</Select.Option>
            <Select.Option value="province">Provincia</Select.Option>
            <Select.Option value="district">Distrito</Select.Option>
          </Select>
        </div>
      ),
      dataIndex:
        filterLocation === "department"
          ? "department"
          : filterLocation === "province"
            ? "province"
            : "district",
      key:
        filterLocation === "department"
          ? "department"
          : filterLocation === "province"
            ? "province"
            : "district",
    },
    {
      title: "Total Ventas",
      dataIndex: "total",
      key: "total",
      render: (text) => `S/ ${text.toFixed(2)}`,
      sorter: (a, b) => a.total - b.total,
      sortDirections: ["descend", "ascend"],
      defaultSortOrder: "descend",
    },
    {
      title: "% Total Ventas",
      dataIndex: "total",
      key: "total",
      render: (_, record) => {
        const total = ((record.total / totalSales) * 100).toFixed(2);
        return `${total}%`;
      },
    },
    {
      title: "Detalles",
      key: "details",
      render: (text, record) => (
        <Button onClick={() => showModal(record)} className="btnCancel">
          Detalles
        </Button>
      ),
      width: 120,
    },
  ];

  const columnsDetails = [
    {
      title: "Nombre del cliente",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Número de teléfono",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Ventas",
      dataIndex: "saleAmount",
      key: "saleAmount",
      render: (total) => `S/ ${total.toFixed(2)}`,
    },
    {
      title: "Categorías",
      dataIndex: "categorias",
      key: "categorias",
      render: (categorias) => categorias?.join(" - "),
      width: 150,
    },
    {
      title: "Marcas",
      dataIndex: "marcas",
      key: "marcas",
      render: (marcas) => marcas?.join(" - "),
      width: 150,
    },
    {
      title: "Cantidad de productos",
      dataIndex: "totalProducts",
      key: "totalProducts",
    },
    {
      title: "Fecha",
      dataIndex: "lastOrderDate",
      key: "lastOrderDate",
    },
  ];

  const dataSource =
    filterLocation === "department"
      ? uniqueDepartment?.map((department) => ({
        department,
        total: getTotalByDepartment(department),
        details: getDetailsByDepartment(department),
        key: department,
      }))
      : filterLocation === "province"
        ? uniqueProvince?.map((province) => ({
          province,
          total: getTotalByProvince(province),
          details: getDetailsByProvince(province),
          key: province,
        }))
        : uniqueDistrict?.map((district) => ({
          district,
          total: getTotalByDistrict(district),
          details: getDetailsByDistrict(district),
          key: district,
        }));

  const exportData = dataSource?.map((item) => {
    const location = item[filterLocation];
    return {
      location,
      total: `S/ ${item.total?.toFixed(2)}`,
      porcentaje: `${((item.total / totalSales) * 100).toFixed(2)}% `,
      marcas: item.details.marcas?.join(", "),
      categorias: item.details.categorias?.join(", "),
    };
  });

  const locationTranslation = {
    location: "Localidad",
    department: "Departamento",
    province: "Provincia",
    district: "Distrito",
  };

  const COLUMNS = [
    {
      title: locationTranslation[filterLocation],
      dataIndex: "location",
      key: "location",
    },
    { title: "total", dataIndex: "total", key: "total" },
    { title: "porcentaje", dataIndex: "porcentaje", key: "porcentaje" },
    { title: "marcas", dataIndex: "marcas", key: "marcas" },
    { title: "categorias", dataIndex: "categorias", key: "categorias" },
  ];

  return (
    <div className="w-full pt-4 pr-4 pl-4">
      <div className="overflow-x-auto h-96">
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
        />
      </div>
      <Modal
        title="Detalles"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={1000}
      >
        <div className="overflow-x-auto h-96">
          <Table
            dataSource={modalData}
            columns={columnsDetails}
            pagination={false}
          />
        </div>
      </Modal>
      <div
        className="flex justify-end my-2 mr-5"
      >
        <ExportToExcel
          data={exportData}
          columns={COLUMNS}
          fileName={`resumen${locationTranslation[filterLocation]}`}
        />
      </div>
    </div>
  );
};
